import { ReactNode } from "react"
import { TextInputProps } from "~/ui/primitives"
import { ValidationRule } from "../../utils"
import { ValidateInputProps } from "~hooks/useValidateInput/types"

export enum InputTextTypes {
  INPUT_TEXT = "input-text",
  INPUT_TEXT_BORDER = "input-text-border",
  INPUT_TEXT_BOTTOM_LINE = "input-text-bottom-line",
  INPUT_TEXT_FLOAT_LABEL = "input-text-float-label",
}

export interface InputTextProps extends TextInputProps {
  label?: string
  validRule?: ValidationRule,
  required?:boolean,
  /** Shown to the right of the input (e.g. password visibility toggle). Float-label variant only. */
  rightAccessory?: ReactNode,
}

export interface InputTextCoreProps extends InputTextProps {
  type: InputTextTypes
}

export interface InputTextComponentInnerProps
  extends TextInputProps,
    InputTextStyledComponentProps,
    Pick<InputTextProps, "label" | "rightAccessory"> {
    }

export interface InputTextStyledComponentProps {
  error: ValidateInputProps["error"]
  isFocus: boolean,
  required?:boolean,
}
